import React, { useEffect, useState } from "react";

const TypeDescriptionHolder = ({ onDescription, type, onRemoveType }) => {
  const [desc, setDesc] = useState("");

  useEffect(() => {
    onDescription(type, desc);
  }, [desc]);
  return (
    <div
      className="divRow"
      style={{ width: "100%", backgroundColor: "#4f4f4f", padding: "2px" }}
    >
      <div
        onClick={() => onRemoveType(type)}
        className="textBoldWhite"
        style={{ fontSize: "16px", backgroundColor: "#2f2f2f" }}
      >
        {type}
      </div>
      <input
        style={{ flex: 1, textAlign: "center" }}
        placeholder="How does the type relate?"
        value={desc}
        onChange={(e) => setDesc(e.target.value.replace(/[^a-z\s?!.,]/gi, ""))}
      />
    </div>
  );
};

export default TypeDescriptionHolder;
